/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';

export default class AppsAppBillingCancelConfirmRoute extends Route {
  @service declare router: Router;
  @service declare appService: any;
  @service declare customerService: $TSFixMe;

  get isSalesforceContractedOrCustomPricing() {
    return (
      this.appService.app.isSalesforceContracted || this.customerService.customer.hasCustomPricing
    );
  }

  beforeModel() {
    if (!this.isSalesforceContractedOrCustomPricing) {
      this.router.transitionTo('apps.app.settings.subscription.billing.settings', {
        queryParams: {
          redirect_source: 'exit_survey',
        },
      });
    }
  }
}
